import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import "../../../../assets/css/customer/subscreens/home/SaleBanner.css";

const Salebanner = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Email submitted:', email);
    setEmail('');
  };

  return (
    <section className="hero-newsletter-section">
      <div className="hero-newsletter-background">
        <Container className="hero-container">
          <Row className="align-items-center hero-newsletter-row">
            {/* Left Side - Text Content */}
            <Col lg={6} md={12} className="hero-text-col">
              <div className="hero-text-content">
                <h1 className="hero-heading">
                  Beautiful Things Begin with a{" "}
                  <span className="highlight-off">Little Creativity</span>
                </h1>
                <p className="hero-subheading">
                  Explore handmade creations made to add beauty to your world.
                </p>
              </div>
            </Col>

            {/* Right Side - Form */}
            <Col lg={6} md={12} className="hero-form-col">
              <div className="hero-form-wrapper">
                <Form onSubmit={handleSubmit} className="hero-newsletter-form">
                  <input
                    type="email"
                    className="hero-email-input"
                    placeholder="Enter Your Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="hero-register-btn">
                    REGISTER NOW
                  </button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default Salebanner;